import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { getData } from "./data"
import Table from "./Table"
import { useSelector, useDispatch } from "react-redux"
import { getAllStaticPages } from "../../../store/StaticPages/actions"
import {sitename} from "../../../constants/constants";

const StaticPages = props => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllStaticPages())
  }, [])

  const StaticPages = useSelector(state => state.staticPages.Index ?? [])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Static Pages" />
        </Container>
        <Table data={StaticPages} />
      </div>
    </React.Fragment>
  )
}

export default withRouter(StaticPages)
